export const getCurrentDate = (action) => {
    return new Date().toISOString().substring(0,10)
}